import { render, staticRenderFns } from "./invoices-list.vue?vue&type=template&id=c9c3b3e8&scoped=true&"
import script from "./invoices-list.vue?vue&type=script&lang=js&"
export * from "./invoices-list.vue?vue&type=script&lang=js&"
import style0 from "./invoices-list.vue?vue&type=style&index=0&id=c9c3b3e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c3b3e8",
  null
  
)

export default component.exports